<template>
	<div>
		<dialogue
		:title="'Success'"
		:paragraph="save_dialogue_text"
		:button_names="['Accept']"
		:show="save_dialogue"
		v-on:cancel="saveDialogue"
		></dialogue>
		<dialogue
		:title="'Error'"
		:paragraph="error_dialogue_text"
		:button_names="['Accept']"
		:show="error_dialogue"
		v-on:cancel="errorDialogue"
		></dialogue>

        <div style="display:flex; flex-direction: row;">
            <div v-if="jobOrderSearch==''" style="height:calc(100vh - 50px); overflow-x: scroll; flex-grow:1;">
                <layout-3 v-if="jobOrderId!=0" :id=id4 :term="jobOrderId" :width=3 :height=3 style="width:100%;"></layout-3>
                <layout-1
                    :table_name="'Job Orders'"
                    :id=id2
                    :searchbar=true
                    :termchange=true
                    :navbar=true
                    :button_name="'Schedules'"
                    :button_perm="'9'"
                    v-on:select="selectJobOrder">
                </layout-1>
            </div>
            <div v-else style="height:calc(100vh - 50px); overflow-x: scroll; flex-grow:1;">
                <layout-3 v-if="jobOrderId!=0" :id=id4 :term="jobOrderId" :width=3 :height=3 style="width:100%;"></layout-3>
                <layout-1
                    :table_name="'Job Schedules'"
                    :id=id3
                    :term=jobOrderSearch
                    :termchange=true
                    :navbar=true
                    :nav_items="['Cancel']"
                    :nav_item_perms="['9']"
                    :button_name="'Assign'"
                    :button_perm="'9'"
                    v-on:select="selectSchedule"
                    style="height:calc(100vh - 50px); overflow-x: scroll; flex-grow: .5 ;">
                </layout-1>
            </div>

            <div class="scroll" style="flex:0 0 35%; height:calc(100vh - 75px); margin-right: 10px;">
                <div class="centered bordered" style="margin:0">
                    <table style="margin:auto; width:99%;" :key="update_key">
                        <tr>
                            <td>
                                WONumber
                            </td>
                            <td>
                                <div>{{table_data[3]}}</div>
                            </td>
                            <td>
                                JobScheduleID
                            </td>
                            <td>
                                {{table_data[2]}}
                            </td>
                            <td>
                                <button v-on:click="selectSchedule('0')">Unassign</button>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Type
                            </td>
                            <td colspan="3">
                                <autocomplete
                                id="typeSearch"
                                v-model=table_data[0]
                                :type="30"
                                style="width:100%;"
                                ></autocomplete>
                            </td>
                        </tr>
                        <tr>
                            <td style="padding-right:5px;">
                                ReportPage
                            </td>
                            <td>
                                <input
                                id="reportSearch"
                                v-model=table_data[1]
                                style="width:100%;"
                                ></input>
                            </td>
                            <td style="text-align: right; vertical-align: middle; padding-right:5px;">
                                kWh
                            </td>
                            <td>
                                <input
                                id="kilowattSearch"
                                v-model=table_data[4]
                                style="width:100%;"
                                ></input>
                            </td>
                            <td>
                            </td>
                        </tr>
                        <tr>
                            <td style="padding-right:5px;">
                                kW
                            </td>
                            <td>
                                <input
                                id="reportSearch"
                                v-model=table_data[5]
                                style="width:100%;"
                                ></input>
                            </td>
                            <td style="text-align: right; vertical-align: middle; padding-right:5px;">
                                Date Time
                            </td>
                            <td>
                                <datetime
                                id="kilowattSearch"
                                v-model=table_data[6]
                                style="width:100%;"
                                ></datetime>
                            </td>
                            <td>
                            </td>
                        </tr>
                        <tr v-for="col, i in checkboxData" style="height:30px;">
                            <td style="height:30px;">
                                {{col[0]}}
                            </td>
                            <td style="height:30px;">
                                <input style="width:30px;" type="checkbox" v-model="col[1]" v-on:click="setCheckbox(i,1)">Yes</input>
                                <input style="width:30px;" type="checkbox" v-model="col[2]" v-on:click="setCheckbox(i,2)">No</input>
                            </td>
                            <td/>
                            <td/>
                            <td v-if="i==checkboxData.length-1">
                                <button v-on:click="setDocData()">Save</button>
                            </td>
                        </tr>
                    </table>
                </div>

                <div class="centered">
                    <input v-model="cropPosY" type="range" min="0" max="500" value="0" class="slider" style="width:250px;" id="skew">
                </div>
                <div class="centered">
                    <input v-model="cropNegX" type="range" min="0" max="500" value="0" orient="vertical" class="slider" id="skew">

                    <document
                        ref="doc"
                        :dir="'doc_'+docID+'.jpg'"
                        :save=save
                        :brightness=parseInt(brightness)
                        :contrast=parseInt(contrast)
                        :rotation=(parseFloat(rotation)+parseFloat(skew))
                        :grid=grid
                        :translateX=parseInt(translateX)
                        :translateY=parseInt(translateY)
                        :scale=parseFloat(scale)
                        :crop="[parseInt(cropPosX), parseInt(cropNegX), parseInt(cropPosY), parseInt(cropNegY)]"
                        :doc_id=docID
                        style="width:70%; height:auto;"
                    ></document>

                    <input v-model="cropPosX" type="range" min="0" max="500" value="0" orient="vertical" class="slider" id="skew">
                </div>
                <div class="centered">
                    <input v-model="cropNegY" type="range" min="0" max="500" value="0" class="slider" style="width:250px;" id="skew">
                </div>

                <div class="bordered">

                    <button v-if="grid==false" v-on:click="grid=!grid" style="height:20px; float:left; margin:10px; font-size:14px"><font-awesome-icon icon="border-all" /></button>
                    <button v-else v-on:click="grid=!grid" style="height:20px; float:left; margin:10px; background-color:#a7a7a7; font-size:14px"><font-awesome-icon icon="border-all" /></button>

                    <div class="centered">
                        <button v-on:click="rotate(false)" style="width:200px; height:20px; margin-right:10px; margin-left:10px; font-size:14px">Rotate -90</button>
                        <button v-on:click="rotate(true)" style="width:200px; height:20px; margin-right:10px; margin-left:10px; font-size:14px">Rotate 90</button>
                    </div>
                    <div class="centered">
                        <table style="table-layout:fixed">
                            <tr>
                                <td style="width: 200px">
                                    <div style="font-size:14px">
                                        Skew : {{skew}}°
                                    </div>
                                </td>
                                <td style="width: 30px;">
                                    <button v-on:click="skew=0" style="height:20px; font-size:14px">0</button>
                                </td>
                                <td>
                                    <input v-model="skew" type="range" min="-45" max="45" step="0.1" value="0" class="slider" id="skew">
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style="font-size:14px">
                                        Translate : ({{translateX}},{{translateY}})px
                                    </div>
                                </td>
                                <td style="width: 30px;">
                                    <button v-on:click="translateX=0; translateY=0;" style="height:20px; font-size:14px">0</button>
                                </td>
                                <td>
                                    <input v-model="translateX" type="range" min="-500" max="500" value="0" class="slider" style="width:calc(50% - 20px);" id="translateX">
                                    <input v-model="translateY" type="range" min="-500" max="500" value="0" class="slider" style="width:calc(50% - 20px); float:right;" id="translateY">
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style="font-size:14px">
                                        Scale : {{scale}}%
                                    </div>
                                </td>
                                <td style="width: 30px;">
                                    <button v-on:click="scale=100" style="height:20px; font-size:14px">0</button>
                                </td>
                                <td>
                                    <input v-model="scale" type="range" min="50" max="150" step="0.1" value="0" class="slider" id="scale">
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style="font-size:14px">
                                        Brightness : {{brightness}}%
                                    </div>
                                </td>
                                <td style="width: 30px">
                                    <button v-on:click="brightness=0" style="height:20px; font-size:14px">0</button>
                                </td>
                                <td>
                                    <input v-model="brightness" type="range" min="-100" max="100" value="50" class="slider" id="brightness">
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <div style="font-size:14px">
                                        Contrast : {{contrast}}%
                                    </div>
                                </td>
                                <td style="width: 30px">
                                    <button v-on:click="contrast=0" style="height:20px; font-size:14px">0</button>
                                </td>
                                <td>
                                    <input v-model="contrast" type="range" min="-100" max="100" value="0" class="slider" id="contrast">
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div class="centered">
                        <button v-on:click="save=!save" style="width:200px; height:20px; margin-right:10px; margin-left:10px; font-size:14px">Save</button>
                    </div>
                </div>
            </div>
        </div>
	</div>
</template>

<script>
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
        id: Number,
		id2: Number,
		id3: Number,
		id4: Number,
		docID: Number,
    },
	data() {
		return {
			jobOrderSearch:'',
			table_data:[],
			brightness:0,
			contrast:0,
			skew:0,
			rotation:0,
			translateX:0,
			translateY:0,
			scale:100,
			cropPosX:0,
			cropNegX:0,
			cropPosY:0,
			cropNegY:0,
			grid:false,
			save:false,

			save_dialogue:false,
			save_dialog_text:'',

			error_dialogue:false,
			error_dialog_text:'',

			checkboxData:[],

            jobOrderId:"0",

			update_key:0,
		}
	},
	async created (){
		this.getTables();
	},
	methods:{
		rotate(right){
			if(right){
				this.rotation+=90;
			}else{
				this.rotation-=90;
			}
		},
		selectSchedule(value){
			if(value[0]==''){
				this.jobOrderSearch='';
				return;
			}

			api.postData(
				{
					type:"insert",
					data:{
						pageid:this.id,
						data:[value[0]],
						term:this.docID,
					}
				}
			).then((res) => {
				if(res.data.errors!=undefined) {
					var message = '';
					for(var i = 0;i<res.data.errors.length;i++){
						message+=", "+res.data.errors[i];
					}
					message = message.slice(2,message.length)

					this.error_dialogue_text = message
					this.error_dialogue = true
			    }else {
					if(value[0]!='0')
						router.push('/'+res.data.to+'?q='+this.jobOrderSearch);
					else
						this.getTables();
			    }
			});
		},
		setDocData(){
            const checkboxOffset = 7;

			for(var i = 0;i<this.checkboxData.length;i++){
				if(this.checkboxData[i][1]==true){
					this.table_data[i+checkboxOffset] = 1
				}else if (this.checkboxData[i][2]==true){
					this.table_data[i+checkboxOffset] = 0
				}else{
					this.table_data[i+checkboxOffset] = 'null'
				}
			}

			api.postData(
				{
					type:"insert",
					data:{
						pageid:this.id,
						term:this.docID,
						data:this.table_data,
					}
				}
			).then((res) => {
				if(res.data.errors!=undefined) {
					var message = '';
					for(var i = 0;i<res.data.errors.length;i++){
						message+=", "+res.data.errors[i];
					}
					message = message.slice(2,message.length)

					this.error_dialogue_text = message
					this.error_dialogue = true
			    }
			});
		},
		saveDialogue(){
			this.save_dialogue = false
			//router.push('/'+res.data.to+'?q='+res.data.search);
			router.go(-1)
		},
		errorDialogue(){
			this.error_dialogue = false
		},
		getTables (){
			api.postData(
				{
					type:"add",
					data:{
						pageid:this.id,
						term:this.docID,
					}
				}
			).then((res) => {
				if(res.data.column_data){
					this.table_data = res.data.column_data;
                    this.jobOrderId = this.table_data[3];
                    const checkboxOffset = 7;
					this.update_key++;

					this.checkboxData = [
						['Has Activities'],
						['Has Report Times'],
						['Has Materials'],
						['Has Work Performed'],
						['Has Remaining Items'],
						['To Be Entered']]
					for(var i = checkboxOffset;i<this.table_data.length;i++){
						if(this.table_data[i] == 0){
							this.checkboxData[i-checkboxOffset][1] = false
							this.checkboxData[i-checkboxOffset][2] = true
						}else if(this.table_data[i] == 1){
							this.checkboxData[i-checkboxOffset][1] = true
							this.checkboxData[i-checkboxOffset][2] = false
						}else{
							this.checkboxData[i-checkboxOffset][1] = false
							this.checkboxData[i-checkboxOffset][2] = false
						}
					}

					this.update_key++;
				}
			});
        },
		selectJobOrder(value){
			this.jobOrderSearch = value[0];
		},
		setData(index,value){
			this.table_data[index]=value;
		},
		setCheckbox(index,i){
			if(i==1){
				this.checkboxData[index][1] = true
				this.checkboxData[index][2] = false
			}else{
				this.checkboxData[index][1] = false
				this.checkboxData[index][2] = true
			}
		},
	},
}
</script>

<style scoped>
table,td {
	background-color: #ffffff;
	empty-cells: show;
	border:0px solid black;
	padding:0px;
}

.centered{
	display:flex;
	flex-wrap: wrap;
	justify-content:center;
	margin:10px;
}

.bordered{
	border-radius:5px;
	border:2px solid #a7a7a7;
}

/* The slider itself */
.slider {
	margin:10px;
	-webkit-appearance: none; /* Override default look */
	appearance: none;
	width: 100%; /* Full-width */
	height: 15px; /* Specified height */
	/*background-color: #e7e7e7; *//* Grey background */
	background-image: linear-gradient(to right, #e7e7e7 24.75%, #a7a7a7 25%, #e7e7e7 25.25%, #e7e7e7 49.75%, #a7a7a7 50%, #e7e7e7 50.25%, #e7e7e7 74.75%, #a7a7a7 75%, #e7e7e7 75.25%);
	border:1px solid #a7a7a7;
	border-radius: 2px;
	-webkit-transition: .2s; /* 0.2 seconds transition on hover */
	transition: background-color .2s;
	padding:1px;
}

.slider[orient=vertical]
{
    writing-mode: bt-lr; /* IE */
    -webkit-appearance: slider-vertical; /* WebKit */
	background-image: linear-gradient(to bottom, #e7e7e7 24.75%, #a7a7a7 25%, #e7e7e7 25.25%, #e7e7e7 49.75%, #a7a7a7 50%, #e7e7e7 50.25%, #e7e7e7 74.75%, #a7a7a7 75%, #e7e7e7 75.25%);
    width: 15px;
    height: 175px;
    padding: 1px;
}

/* Mouse-over effects */
.slider:hover {
	background-color: #c7c7c7;
}

/* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
.slider::-webkit-slider-thumb {
	-webkit-appearance: none; /* Override default look */
	appearance: none;
	width: 10px; /* Set a specific slider handle width */
	height: 10px; /* Slider handle height */
	border-radius: 3px;
	background: #35495E;
	cursor: pointer; /* Cursor on hover */
}

.slider::-moz-range-thumb {
	width: 10px; /* Set a specific slider handle width */
	height: 10px; /* Slider handle height */
	border-radius: 3px;
	background: #35495E;
	cursor: pointer; /* Cursor on hover */
}

/* The slider handle (use -webkit- (Chrome, Opera, Safari, Edge) and -moz- (Firefox) to override default look) */
.slider[orient=vertical]::-webkit-slider-thumb {
	-webkit-appearance: none; /* Override default look */
	appearance: none;
	width: 10px; /* Set a specific slider handle width */
	height: 10px; /* Slider handle height */
	border-radius: 3px;
	background: #35495E;
	cursor: pointer; /* Cursor on hover */
}

.slider[orient=vertical]::-moz-range-thumb {
	width: 10px; /* Set a specific slider handle width */
	height: 10px; /* Slider handle height */
	border-radius: 3px;
	background: #35495E;
	cursor: pointer; /* Cursor on hover */
}
</style>



// WEBPACK FOOTER //
// src/layouts/layout_6.vue